<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
                <el-button type="primary" @click="exportOpen()" v-if="checkPermissionButton('导出Excel')">导出Excel</el-button>
            </div>
            <div class="header-right" v-if="pageMap.filter">
                <el-date-picker v-model="monthRange" type="monthrange" format="yyyyMM" value-format="yyyyMM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" style="margin-right: 10px;" @change="monthRangeChange">
                </el-date-picker>
                <el-select v-model="filterParams.inventory_common_status" placeholder="请选择结算状态" style="width: 185px; margin-right: 10px;" @change="loadData(1)">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已结账" :value="1"></el-option>
                    <el-option label="未结账" :value="0"></el-option>
                </el-select>
                <el-input v-for="item in pageMap.filter" v-model="filterParams[item.prop]"
                    :placeholder="'请输入' + item.label" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column prop="inventoryCommonMonth" label="月份" width="90"></el-table-column>
            <el-table-column prop="inventoryCustomerName" label="公司名称" width="300">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerName)">{{ scope.row.inventoryCustomerName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCustomerPerson" label="负责人">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerPerson)">{{ scope.row.inventoryCustomerPerson }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCategoryName" label="项目">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCategoryName)">{{ scope.row.inventoryCategoryName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="计划">
                <el-table-column prop="inventoryAccountPlanFeeTotal" label="上游计划合计">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanFeeTotal)">{{ scope.row.inventoryAccountPlanFeeTotal }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryPaymentPlanFeeTotal" label="下游计划合计">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentPlanFeeTotal)">{{ scope.row.inventoryPaymentPlanFeeTotal }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryCommonPlanProfit" label="计划利润">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCommonPlanProfit)">{{ scope.row.inventoryCommonPlanProfit }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="实际">
                <el-table-column prop="inventoryAccountActualTotal" label="上游实际合计">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualTotal)">{{ scope.row.inventoryAccountActualTotal }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryPaymentActualFeeTotal" label="下游实际合计">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualFeeTotal)">{{ scope.row.inventoryPaymentActualFeeTotal }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryCommonActualProfit" label="实际利润">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCommonActualProfit)">{{ scope.row.inventoryCommonActualProfit }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="上游结算" width="90">
                <template slot-scope="scope">
                    <el-tag style="cursor: pointer;" v-if="scope.row.inventoryAccountActualStatus != '-' && checkPermissionButton('上游结算')" :type="scope.row.inventoryAccountActualStatus == 1 ? 'success' : 'error'" @click="updateStatus(scope.row.inventoryPaymentId ,'inventoryAccountActualStatus', scope.row.inventoryAccountActualStatus)">{{ scope.row.inventoryAccountActualStatus == 1 ? "已结账" : "未结账" }}</el-tag>
                    <el-tag style="cursor: pointer;" v-if="scope.row.inventoryAccountActualStatus != '-' && !checkPermissionButton('上游结算')" :type="scope.row.inventoryAccountActualStatus == 1 ? 'success' : 'error'">{{ scope.row.inventoryAccountActualStatus == 1 ? "已结账" : "未结账" }}</el-tag>
                    <span v-if="scope.row.inventoryAccountActualStatus == '-'">-</span>
                </template>
            </el-table-column>
            <el-table-column label="下游结算" width="90">
                <template slot-scope="scope">
                    <el-tag style="cursor: pointer;" v-if="scope.row.inventoryPaymentActualStatus != '-' && checkPermissionButton('下游结算')" :type="scope.row.inventoryPaymentActualStatus == 1 ? 'success' : 'error'" @click="updateStatus(scope.row.inventoryPaymentId ,'inventoryPaymentActualStatus' ,scope.row.inventoryPaymentActualStatus)">{{ scope.row.inventoryPaymentActualStatus == 1 ? "已结账" : "未结账" }}</el-tag>
                    <el-tag style="cursor: pointer;" v-if="scope.row.inventoryPaymentActualStatus != '-' && !checkPermissionButton('下游结算')" :type="scope.row.inventoryPaymentActualStatus == 1 ? 'success' : 'error'">{{ scope.row.inventoryPaymentActualStatus == 1 ? "已结账" : "未结账" }}</el-tag>
                    <span v-if="scope.row.inventoryPaymentActualStatus == '-'">-</span>
                </template>
            </el-table-column>
            <!-- 操作栏 -->
            <el-table-column label="查看" width="60" fixed="right" v-if="checkPermissionButton('查看')">
                <template slot-scope="scope" v-if="scope.row.inventoryCommonMonth != '合计'">
                    <el-button @click="showDetail(scope.row)" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 1000]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <!-- 导出弹窗 -->
        <el-dialog title="选择导出设置" :visible.sync="isExport" width="30%">
            <el-checkbox-group v-model="exportChecked">
                <el-checkbox :label="item.name" v-for="item in exportMap"></el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isExport = false">取 消</el-button>
                <el-button type="primary" @click="exportConfirm()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->
        <div v-if="isDetail" style="position: fixed; top: 0px; left: 0px; z-index: 9; width: 100%; height: 100vh; background: #FFFFFF;">
            <PaymentDetailComponent :payment-id="paymentId" @close="isDetail = false"></PaymentDetailComponent>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import PaymentDetailComponent from "@/components/PaymentDetailComponent.vue"

import { API, doGet, doPost } from "@/api/api.js"

export default {
    components: {
        PaymentDetailComponent,
    },
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            paymentId: "",
            isDetail: false,
            type: "",
            customers: [],
            monthRange: [],
        }
    },
    methods: {
        updateStatus: async function(id, column, value) {
            let resultObj = await doPost(API.PAYMENT_UPDATE_STATUS, {
                id: id,
                column: column,
                value: value == 1 ? 0 : 1
            });
            this.showResult(resultObj);
        },
        showDetail: function(row) {
            this.paymentId = row.inventoryPaymentId;
            this.isDetail = true;
        },
        monthRangeChange: function (e) {
            if (e) {
                this.filterParams.inventory_common_month_start = e[0];
                this.filterParams.inventory_common_month_end = e[1];
            }
            else {
                this.monthRange = [];
                this.filterParams.inventory_common_month_start = "";
                this.filterParams.inventory_common_month_end = "";
            }
            this.loadData(1);
        },
        getCustomers: async function () {
            this.customers = await doGet("/inventoryCustomer" + API.ALL);
        },
        beforeHandleOpenEx: function (handle, info, type) {
            this.type = type;
            if (handle == "update") {
                this.handleInfo.type = type;
            }
        },
        afterInitialData: function () {
            if (this.records && this.records.length > 0) {
                let inventoryAccountPlanTradeAmount = 0;
                let inventoryAccountPlanFeeTotal = 0;
                let inventoryAccountActualTotal = 0;
                let inventoryPaymentPlanFeeTotal = 0;
                let inventoryPaymentActualFeeTotal = 0;
                let inventoryPaymentPay = 0;
                let inventoryPaymentUnpay = 0;
                let inventoryCommonPlanProfit = 0;
                let inventoryCommonActualProfit = 0;
                for (let i = 0; i < this.records.length; i++) {
                    inventoryAccountPlanTradeAmount += this.records[i].inventoryAccountPlanTradeAmount;
                    inventoryAccountPlanFeeTotal += this.records[i].inventoryAccountPlanFeeTotal;
                    inventoryAccountActualTotal += this.records[i].inventoryAccountActualTotal;
                    inventoryPaymentPlanFeeTotal += this.records[i].inventoryPaymentPlanFeeTotal;
                    inventoryPaymentActualFeeTotal += this.records[i].inventoryPaymentActualFeeTotal;
                    inventoryPaymentPay += this.records[i].inventoryPaymentPay;
                    inventoryPaymentUnpay += this.records[i].inventoryPaymentUnpay;
                    inventoryCommonPlanProfit += this.records[i].inventoryCommonPlanProfit;
                    inventoryCommonActualProfit += this.records[i].inventoryCommonActualProfit;
                }
                this.records.push({
                    inventoryCommonMonth: '合计',
                    inventoryCustomerName: '-',
                    inventoryCustomerPerson: '-',
                    inventoryCategoryName: '-',
                    inventoryCommonStatus: '-',
                    inventoryAccountPlanTradeAmount: inventoryAccountPlanTradeAmount.toFixed(1),
                    inventoryAccountPlanFeeTotal: inventoryAccountPlanFeeTotal.toFixed(1),
                    inventoryAccountActualTotal: inventoryAccountActualTotal.toFixed(1),
                    inventoryPaymentPlanFeeTotal: inventoryPaymentPlanFeeTotal.toFixed(1),
                    inventoryPaymentActualFeeTotal: inventoryPaymentActualFeeTotal.toFixed(1),
                    inventoryPaymentPay: inventoryPaymentPay.toFixed(1),
                    inventoryPaymentUnpay: inventoryPaymentUnpay.toFixed(1),
                    inventoryCommonPlanProfit: inventoryCommonPlanProfit.toFixed(1),
                    inventoryCommonActualProfit: inventoryCommonActualProfit.toFixed(1)
                });
            }
        }
    },
    created: function () {
        this.tag = "inventoryPayment";
        this.getCustomers();
        this.exportMap = [
            //COMMON
            { name: "月份", value: "inventoryCommonMonth", checked: true }, 
            { name: "公司名称", value: "inventoryCustomerName", checked: true }, 
            { name: "负责人", value: "inventoryCustomerPerson", checked: true }, 
            { name: "项目", value: "inventoryCategoryName", checked: true }, 
            //合计
            { name: "上游计划合计", value: "inventoryAccountPlanFeeTotal", checked: true }, 
            { name: "下游计划合计", value: "inventoryPaymentPlanFeeTotal", checked: true }, 
            { name: "计划利润", value: "inventoryCommonPlanProfit", checked: true }, 
            { name: "上游实际合计", value: "inventoryAccountActualTotal", checked: true }, 
            { name: "下游实际合计", value: "inventoryPaymentActualFeeTotal", checked: true }, 
            { name: "实际利润", value: "inventoryCommonActualProfit", checked: true }, 
            { name: "上游结算", value: "inventoryAccountActualStatus", checked: true }, 
            { name: "下游结算", value: "inventoryPaymentActualStatus", checked: true }
        ];
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";

::v-deep .dialog-full-screen {
  // 1️⃣ 遮罩容器禁止页面滚动（干掉外层滚动条）
  .el-dialog__wrapper {
    overflow: hidden !important;
  }
  // 2️⃣ 弹窗严格限制在视口内，不会溢出屏幕
  .el-dialog {
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    margin: 0 !important;
    border-radius: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important; // 弹窗本身禁止滚动
    margin-bottom: 0 !important;
  }
  // 3️⃣ 只保留内容区滚动（唯一滚动条）
  .el-dialog__body {
    flex: 1;
    overflow-y: auto !important;
    padding: 0 !important;
  }
}
</style>